import { useLocation, useParams } from "react-router";
import { Redirect } from "react-router-dom";

import { nameToFirstName } from "@aclymatepackages/converters";

import DashboardLayout from "../layouts/DashboardLayout";

import Dashboard from "./Dashboard";
import Offsets from "./Offsets";
import Settings from "./Settings";

import { useAuth, useCollectionDataListener } from "../../../helpers/firebase";

const getGreetingByTime = () => {
  const hour = new Date().getHours();

  if (hour < 12) {
    return "Good morning";
  }

  if (hour < 18) {
    return "Good afternoon";
  }

  return "Good evening";
};

const buildRedirectTo = (basePath, baseQuery, search) => {
  const extra = new URLSearchParams(search || "").toString();
  return `${basePath}?${baseQuery}${extra ? `&${extra}` : ""}`;
};

const DashboardIndex = () => {
  const { view } = useParams();
  const location = useLocation();
  const [user] = useAuth();
  const { displayName } = user || {};
  const safeDisplayName = displayName || "";

  const [customers, customersLoading] = useCollectionDataListener("customers");

  if (!user) {
    return <Redirect to="/explorer" />;
  }

  if (view === "emissions") {
    return <Redirect to="/explorer/dashboard" />;
  }

  if (view === "products") {
    return (
      <Redirect
        to={buildRedirectTo(
          "/explorer/dashboard",
          "view=products",
          location.search
        )}
      />
    );
  }

  if (view === "customers") {
    return (
      <Redirect
        to={buildRedirectTo(
          "/explorer/dashboard",
          "view=customers",
          location.search
        )}
      />
    );
  }

  if (view === "suppliers") {
    return (
      <Redirect
        to={buildRedirectTo(
          "/explorer/dashboard",
          "view=suppliers",
          location.search
        )}
      />
    );
  }

  if (view === "team") {
    return (
      <Redirect
        to={buildRedirectTo(
          "/explorer/dashboard/settings",
          "tab=team",
          location.search
        )}
      />
    );
  }

  const viewsMaps = {
    offsets: {
      content: <Offsets />,
      title: null,
      subtitle: null
    },
    settings: {
      content: <Settings />,
      title: "Settings",
      subtitle:
        "Manage your sustainability goals, documents, team, and offset purchases"
    }
  };

  const { content, title } = viewsMaps[view] || {};
  const isCanvasView = !view || view === "dashboard" || view === "offsets";

  const resolvedTitle = isCanvasView
    ? title || null
    : title || `${getGreetingByTime()}, ${nameToFirstName(safeDisplayName)}!`;

  return (
    <DashboardLayout title={resolvedTitle}>
      {content || (
        <Dashboard customers={customers} customersLoading={customersLoading} />
      )}
    </DashboardLayout>
  );
};
export default DashboardIndex;
